var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsOutRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 6v6a1 1 0 01-2 0V8.414l-5.293 5.293a1 1 0 11-1.415-1.415L23.587 7H20a1 1 0 110-2h6a1 1 0 011 1zM12.293 18.293L7 23.585V20a1 1 0 10-2 0v6a1 1 0 001 1h6a1 1 0 000-2H8.414l5.293-5.293a1 1 0 10-1.415-1.415zM26 19a1 1 0 00-1 1v3.586l-5.293-5.293a1 1 0 10-1.415 1.415L23.587 25H20a1 1 0 000 2h6a1 1 0 001-1v-6a1 1 0 00-1-1zM8.414 7H12a1 1 0 100-2H6a1 1 0 00-1 1v6a1 1 0 102 0V8.414l5.293 5.293a1 1 0 101.415-1.415L8.413 7z"
  })));
}
export default SvgArrowsOutRegular;